import { Container } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurColor,
    getPurpurShadow,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';
import {
    NAVIGATION_OFFSET_CSS_VARIABLE,
    NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE,
} from '@telialt/utils/src/NavigationUtils/constants';

export const StickySummaryWrapper = styled.div<{ $isVisible: boolean }>`
    display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1041;
    left: 0;
    top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    transition: var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
    width: 100%;
`;

export const StickySummarySection = styled.div`
    width: 100%;
    background-color: ${getPurpurColor('backgroundSecondary')};
    box-shadow: ${getPurpurShadow('md')};
    position: relative;
    z-index: 1040;
`;

export const StickySummaryContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: ${getPurpurSpacing('150')};
    padding-bottom: ${getPurpurSpacing('150')};

    ${purpurMedia('lg')`
        padding-top: ${getPurpurSpacing('250')};
        padding-bottom: ${getPurpurSpacing('250')};
    `}
`;

export const StickySummaryProductName = styled.div`
    font-size: ${getPurpurTypography('scale200')};
    font-weight: ${getPurpurTypography('weightBold')};
    line-height: ${getPurpurTypography('lineHeightDefault')};
    word-wrap: break-word;
    flex-shrink: 0;
    display: none;

    ${purpurMedia('lg')`
        display: block;
    `}
`;

export const StickySummaryPriceBlock = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: flex-end;
    width: 100%;
`;
